export const securityFilter = (value, langData) => {
    if (value.includes("<") || value?.includes("</") || value?.includes(">") || value?.includes("='") || value?.includes('="')) {
        // Swal.fire({ icon: 'info', text: langFilter(langData, "Sorry_Special_characters_not_allowed") })
        return false
    } else {
        return value
    }
}